/*ChatbotWidget.jsx*/
import React from 'react';
import { 
  useState, 
  useRef, 
  useEffect 
} from 'react';
import './DBHChatbot.css';

const ChatbotWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleSendMessage = async () => {
    if (!inputValue.trim()) return;
  
    // Add user message
    const userMessage = { text: inputValue, sender: 'user' };
    setMessages(prev => [...prev, userMessage]);
    setInputValue('');
  
    try {
      const response = await fetch('http://localhost:4578/chat', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ message: inputValue }),
      });
  
      const data = await response.json();
      
      // Add bot response
      const botMessage = { text: data.response, sender: 'bot' };
      setMessages(prev => [...prev, botMessage]);
    } catch (error) {
      const errorMessage = { text: "Sorry, I'm having trouble connecting.", sender: 'bot' };
      setMessages(prev => [...prev, errorMessage]);
    }
  };
  

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSendMessage();
    }
  };

  return (
    <div className={`chatbot-container ${isOpen ? 'open' : ''}`}>
      <div className="chatbot-header" onClick={() => setIsOpen(!isOpen)}>
        <h3>DataBoltAI Assistant</h3>
        <span>{isOpen ? '×':'💬'}</span>
      </div>
      
      {isOpen && (
        <div className="chatbot-content">
          <div className="chatbot-messages">
            {messages.length === 0 ? (
              <div className="welcome-message">
                <p>Hello! I'm your DataBoltAI assistant. How can I help you today?</p>
              </div>
            ) : (
              messages.map((msg, index) => (
                <div key={index} className={`message ${msg.sender}`}>
                  {msg.text}
                </div>
              ))
            )}
            <div ref={messagesEndRef} />
          </div>
          
          <div className="chatbot-input">
            <input
              type="text"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              onKeyPress={handleKeyPress}
              placeholder="Type your message..."
            />
            <button onClick={handleSendMessage}>Send</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatbotWidget;

// src/components/DBHChatbot.js
// src/components/DBHChatbot.js
// import React, { useState, useRef, useEffect } from 'react';
// import './DBHChatbot.css';

// const DBHChatbot = () => {
//   const [messages, setMessages] = useState([]);
//   const [inputValue, setInputValue] = useState('');
//   const messagesEndRef = useRef(null);

//   const scrollToBottom = () => {
//     messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
//   };

//   useEffect(() => {
//     scrollToBottom();
//   }, [messages]);

//   const handleSendMessage = async () => {
//     if (!inputValue.trim()) return;

//     const userMessage = { text: inputValue, sender: 'user' };
//     setMessages((prev) => [...prev, userMessage]);
//     setInputValue('');

//     try {
//       const response = await fetch('http://localhost:4578/chat', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ message: inputValue }),
//       });

//       const data = await response.json();
//       const botMessage = { text: data.response, sender: 'bot' };
//       setMessages((prev) => [...prev, botMessage]);
//     } catch (error) {
//       const errorMessage = { text: "Sorry, I'm having trouble connecting.", sender: 'bot' };
//       setMessages((prev) => [...prev, errorMessage]);
//     }
//   };

//   const handleKeyPress = (e) => {
//     if (e.key === 'Enter') {
//       handleSendMessage();
//     }
//   };

//   return (
//     <div className="dbh-chatbot-page">
//       <div className="dbh-chatbot-window">
//         <div className="dbh-chatbot-header">
//           <h3>DataBoltAI Assistant</h3>
//         </div>

//         <div className="dbh-chatbot-messages">
//           {messages.length === 0 ? (
//             <div className="welcome-message">
//               <p>Hello! I'm your DataBoltAI assistant. How can I help you today?</p>
//             </div>
//           ) : (
//             messages.map((msg, index) => (
//               <div key={index} className={`message ${msg.sender}`}>
//                 {msg.text}
//               </div>
//             ))
//           )}
//           <div ref={messagesEndRef} />
//         </div>

//         <div className="chatbot-input">
//           <input
//             type="text"
//             value={inputValue}
//             onChange={(e) => setInputValue(e.target.value)}
//             onKeyPress={handleKeyPress}
//             placeholder="Type your message..."
//           />
//           <button onClick={handleSendMessage}>Send</button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default DBHChatbot;

